import React from 'react';
import { CustomPicker } from 'react-color';
import reactCSS from 'reactcss'
import map from 'lodash/map'
import classnames from 'classnames';
import autobind from 'autobind-decorator'
import { isDescendant } from "../../utils/DomHelper"
import WindowEventHelper from "../../lib/WindowEventHelper";


const styles = reactCSS({
    'default': {

    },
})

class TColorPicker extends React.Component {
    constructor(props) {
        super();
        const { propertyName, selected } = props;
        this.props = props;
        this.state = {
            value: String(selected[propertyName]).toUpperCase(),
            open_layer : false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.toggleLayer = this.toggleLayer.bind(this);
        this.handleColorClick = this.handleColorClick.bind(this);
        this.handleTextInput = this.handleTextInput.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
		WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleWindowClick)
    }

    @autobind
    handleWindowClick(e) {
        const { root } = this.refs
        let target = e.target

        if (!isDescendant(root, target)) {
            this.handleClose()
        }
    }

    handleClose() {
        this.setState({
            open_layer: false
        })
    }

    handleChange(e, value) {
        const { propertyName } = this.props;
        if (value == '투명')
            value = 'TRANSPARENT';

        if (!!this.props.label) {
            this.props.onChange && this.props.onChange({ [this.props.label]: value }, e)
        } else {
            this.props.onChange && this.props.onChange(value, e)
        }

        this.setState({ value: value });

        this.props.selectItem(propertyName, value);
    }

    handleColorClick(e) {
        this.handleClose();
        this.handleChange(e, e.target.title);
        e.preventDefault();
        e.stopPropagation();
    }

    handleTextInput(e) {
        this.handleChange(e, e.target.value);
    }

    toggleLayer(e) {
        this.setState( {
            open_layer : !this.state.open_layer
        });
    }

    render() {
        const { defaultClassName } = this.props;
        const style = this.state.value != 'TRANSPARENT'? {background:this.state.value}:null;
        return (
            <div ref="root" className={classnames(defaultClassName, {'opt_open' : this.state.open_layer})}>
                <button type="button" className="btn_opt" onClick={ (e) => this.toggleLayer(e) }>
                    <span className={classnames("bg_color",{'checkboard':(this.state.value == 'TRANSPARENT')}) } style={style} >{this.state.value}</span>
                    <span className="ico_blog ico_open"/>
                </button>
                <div style={{ 'top': 0, 'left': 0, 'width': '100%', 'minWidth': 0, 'maxWidth': 'none',
                    'padding': '0 0 8px','borderRadius': '1px', 'boxSizing': 'border-box',
                    'position': 'absolute',
                    'border': '1px solid #A5ADBA',
                    'background': '#fff',
                    'box-shadow': '0 2px 3px rgba(0,0,0,0.12)',
                    'display': !this.state.open_layer? 'none':'block'} }>
                    <button className="btn_close" type="button" style={{height:'auto',
                        width: '100%',
                        height: '34px',
                        padding: '4px 0 2px 0',
                        fontSize: '14px',
                        textAlign: 'left',
                        textIndent: '9px',
                        boxSizing: 'border-box',
                        boxShadow: '0 1px 0px rgba(0,0,0,0.08)',
                    }} onClick={ (e) => this.toggleLayer(e) }>
                        <span className={classnames("bg_color",{'checkboard':(this.state.value == 'TRANSPARENT')}) } style={{...style,marginTop:'1px'}} >{this.state.value}</span>
                        <span className="ico_blog" style={{
                            position: 'absolute',
                            right: '11px',
                            top: '14px',
                            margin: '0'
                        }}/>
                    </button>
                    <input
                        className="colorpicker-input"
                        value={ this.state.value=='TRANSPARENT'?'투명':this.state.value }
                        onChange={ this.handleTextInput }
                    />
                    <div style={{paddingTop:'6px', paddingLeft: '9px',}}>
                        { map(this.props.colors, (c) => (
                            <div
                                className={(c == 'TRANSPARENT')?'checkboard':''}
                                style={ { width: '12px',height: '12px',float: 'left', marginRight: '1px', marginBottom: '1px', position: 'relative', cursor: 'pointer',backgroundColor: c, boxSizing:'border-box', border:c.toUpperCase() === this.state.value? '1px solid #000000': c.toUpperCase() === '#FFFFFF'?'1px solid #CDCDCD':'0'} }
                                color={ c }
                                onClick={ this.handleColorClick }
                                title={ c }
                                tabIndex={ 0 }
                                onKeyDown={ (e) => e.keyCode === 13 && onClick(c, e) }
                            />
                        )) }
                        <div style={ styles.clear } />
                    </div>

                </div>
            </div>
        );
    }
}

TColorPicker.defaultProps = {
    colors: ['#FF0000', '#FF5400', '#FEB802', '#FFE300', '#95F400', '#02DF01','#00D9FF', '#0150FE', '#1100FF', '#6B00FF', '#FF00E1', '#FE0081', '#000000', '#FFFFFF',
        '#F9D8D8', '#FEDFD3', '#FDECC1', '#FAF3BA', '#DFF7B5', '#C2FCC4','#CCF4F9', '#D7E5FF', '#DAD8FE', '#EBD8FF', '#FFD7FC', '#FFD8ED', '#F6F6F6', '#E9E9E9',
        '#FFA2A6', '#FFBE9B', '#FFE084', '#FCED71', '#C5F46C', '#A7F1AB','#A2EBF4', '#ACCCFF', '#B6B1FE', '#D7B0FF', '#FEADF7', '#FEAFDA', '#D5D5D5', '#BDBDBD',
        '#FF565E', '#FF935B', '#F8C954', '#E6D74B', '#AFE649', '#62E775','#00D2E4', '#5B9AFF', '#6E63FF', '#AF60FE', '#FF55DF', '#FE56A8', '#A5A5A5', '#8B8B8B',
        '#DB303B', '#D86E37', '#D2A52E', '#C6B724', '#94CA1E', '#00CA23','#00BACD', '#3372DC', '#493DDE', '#893ADD', '#EC31CA', '#E9338E', '#737373', '#5D5D5D',
        '#A50000', '#A63201', '#9E6F01', '#9F6F00', '#5D9A00', '#009D06','#008299', '#01329D', '#0C009C', '#45009D', '#A60088', '#A6004D', '#4C4C4C', '#353535',
        '#700000', '#6E2101', '#6A4A00', '#685C00', '#3E6701', '#027607','#005867', '#00216A', '#060068', '#2F0069', '#70005A', '#6F0034', '#212121', 'TRANSPARENT',
    ],
}

export default CustomPicker(TColorPicker);
